import { Component, Input, Output, EventEmitter } from '@angular/core'
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Input() maxWidth?: number = 700
  @Input() maxHeight?: number
  @Input() zIndex: number = 1000
  @Input() disablePrimaryButton?: boolean
  @Input() disableSecondaryButton?: boolean
  @Input() labelPrimaryButton: string = ''
  @Input() labelSecondaryButton?: string
  @Input() hideCloseButton: boolean = false

  @Output() primaryButtonClick = new EventEmitter<void>()
  @Output() secondaryButtonClick = new EventEmitter<void>()
  @Output() closeButtonClick = new EventEmitter<void>()
  @Output() backgroundClick = new EventEmitter<void>()

  public onBackgroundClick() {
    this.backgroundClick.emit()
  }

  public onCloseButtonClick() {
    this.closeButtonClick.emit()
  }

  public onPrimaryButtonClick() {
    this.primaryButtonClick.emit()
  }

  public onSecondaryButtonClick() {
    this.secondaryButtonClick.emit()
  }
}
